(function () {
    'use strict';

    angular.module("imApp").factory("acVatCodeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3429,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3430,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
